/* KHERAJANI COMPUTERS storefront behaviour - original, dependency-free */
(function () {
  'use strict';
  window.__khcInit = true;
  var root = document.documentElement;
  root.classList.add('khc-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- horizontal scrollers ---------- */
  function syncScroller(s) {
    var w = s.closest('[data-khc-scroller]');
    if (!w) return;
    var p = $('[data-khc-prev]', w), n = $('[data-khc-next]', w);
    if (p) p.classList.toggle('is-on', s.scrollLeft > 12);
    if (n) n.classList.toggle('is-off', s.scrollLeft + s.clientWidth >= s.scrollWidth - 12);
  }

  /* ---------- header ---------- */
  var hdr, scrim, closeTimer, openTimer;
  function setActive(item) {
    if (!hdr) return;
    $$('.khc-nav__item.is-open', hdr).forEach(function (i) { if (i !== item) i.classList.remove('is-open'); });
    if (item) {
      item.classList.add('is-open');
      hdr.setAttribute('data-open', '');
      if (scrim) scrim.classList.add('is-on');
      var l = $('.khc-nav__link', item);
      if (l && item.querySelector('.khc-mega')) l.setAttribute('aria-expanded', 'true');
    } else {
      hdr.removeAttribute('data-open');
      if (scrim) scrim.classList.remove('is-on');
    }
    $$('.khc-nav__item:not(.is-open) .khc-nav__link', hdr).forEach(function (l) { l.removeAttribute('aria-expanded'); });
  }
  function closeMega() { clearTimeout(openTimer); setActive(null); }

  function initHeader() {
    hdr = $('[data-khc-header]');
    if (!hdr || hdr.getAttribute('data-ready')) return;
    hdr.setAttribute('data-ready', '1');
    scrim = $('.khc-scrim', hdr);

    var onScroll = function () { hdr.classList.toggle('is-scrolled', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var canHover = window.matchMedia('(hover:hover) and (min-width:990px)').matches;
    $$('.khc-nav__item', hdr).forEach(function (item) {
      var mega = $('.khc-mega', item);
      if (!mega) return;
      if (canHover) {
        item.addEventListener('mouseenter', function () {
          clearTimeout(closeTimer);
          var already = hdr.hasAttribute('data-open');
          clearTimeout(openTimer);
          openTimer = setTimeout(function () { setActive(item); }, already ? 0 : 90);
        });
        item.addEventListener('mouseleave', function () {
          clearTimeout(openTimer);
          closeTimer = setTimeout(closeMega, 140);
        });
      }
      item.addEventListener('focusin', function () { setActive(item); });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) closeMega();
      });
      /* touch laptops / tablets: first tap opens the panel, second follows the link */
      var link = $('.khc-nav__link', item);
      link.addEventListener('click', function (e) {
        if (window.matchMedia('(hover:none)').matches && !item.classList.contains('is-open')) {
          e.preventDefault();
          setActive(item);
        }
      });
    });
    if (scrim) scrim.addEventListener('click', closeMega);

    /* mobile drawer */
    var burger = $('[data-khc-burger]', hdr), mobile = $('.khc-mobile', hdr);
    function toggleMobile(force) {
      if (!burger || !mobile) return;
      var o = typeof force === 'boolean' ? force : !mobile.classList.contains('is-open');
      mobile.classList.toggle('is-open', o);
      burger.setAttribute('aria-expanded', o ? 'true' : 'false');
      if (scrim) scrim.classList.toggle('is-on', o);
    }
    if (burger) burger.addEventListener('click', function () { toggleMobile(); });
    if (scrim) scrim.addEventListener('click', function () { toggleMobile(false); });
    $$('.khc-mobile details', hdr).forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) $$('.khc-mobile details', hdr).forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
    window.addEventListener('resize', function () { if (window.innerWidth >= 990) toggleMobile(false); });
  }

  /* ---------- search (Shopify predictive search endpoint) ---------- */
  var searchEl, searchInput, searchRes, searchTimer, searchCtl, lastQ = '';
  function money(v) {
    try {
      var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AED';
      if (cur === 'AED') { var pp = parseFloat(v).toFixed(2).split('.'); return '⃃ ' + pp[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (pp[1] === '00' ? '' : '.' + pp[1]); }
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur, maximumFractionDigits: 0 }).format(parseFloat(v));
    } catch (e) { return v; }
  }
  function shortTitle(t) {
    t = (t || '').split(' [')[0].split(' | ')[0];
    t = t.replace(/ in Dubai/g, '').replace(/ Dubai/g, '').replace(/ ?Camcity/gi, '');
    var d = 0, c = -1, i, ch, cut = false, closed = false;
    for (i = 0; i < t.length; i++) { ch = t.charAt(i); if (ch === '(') d++; else if (ch === ')') d = Math.max(0, d - 1); else if (ch === ',' && d === 0 && t.charAt(i + 1) === ' ') { c = i; break; } }
    if (c > 12) t = t.slice(0, c);
    t = t.trim();
    if (t.length > 62) { t = t.slice(0, 62); t = t.slice(0, Math.max(t.lastIndexOf(' '), 30)); cut = true; }
    if ((t.match(/\(/g) || []).length > (t.match(/\)/g) || []).length) {
      var k = t.lastIndexOf(', ');
      if (k > t.lastIndexOf('(')) { t = t.slice(0, k) + ')'; closed = true; } else { t = t.replace(/\s*\([^)]*$/, ''); cut = true; }
    }
    t = t.replace(/[\s,;:\-–]+$/, '');
    return cut && !closed ? t + '…' : t;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
  function openSearch() {
    if (!searchEl) return;
    var bar = $('.khc-hdr__bar');
    if (bar) {
      var r = bar.getBoundingClientRect();
      searchEl.style.setProperty('--khc-sb', Math.round(r.bottom + 10) + 'px');
      searchEl.style.setProperty('--khc-sr', Math.max(12, Math.round(root.clientWidth - r.right)) + 'px');
    }
    searchEl.classList.add('is-open');
    root.classList.add('khc-lock');
    requestAnimationFrame(function () { searchEl.classList.add('is-in'); if (searchInput) searchInput.focus(); });
  }
  function closeSearch() {
    if (!searchEl || !searchEl.classList.contains('is-open')) return;
    searchEl.classList.remove('is-in');
    root.classList.remove('khc-lock');
    setTimeout(function () { searchEl.classList.remove('is-open'); }, reduce ? 0 : 260);
  }
  function emptyState(q) {
    var chips = $$('.khc-nav__link', hdr || document).filter(function (a) { return a.getAttribute('href') && a.getAttribute('href').charAt(0) !== '#'; }).slice(0, 5).map(function (a) {
      return '<a class="khc-chip" href="' + esc(a.getAttribute('href')) + '">' + esc(a.textContent.trim()) + '</a>';
    }).join('');
    var wa = $('.khc-as__wa');
    var waHref = wa ? String(wa.getAttribute('href') || '').split('?')[0] + '?text=' + encodeURIComponent('Hello Kherajani Computers, I could not find this on the website: ' + q) : '';
    return '<div class="khc-search__empty"><strong style="display:block;color:var(--khc-ink);font-size:15px">No products found for &ldquo;' + esc(q) + '&rdquo;</strong>' +
      '<span style="display:block;margin-top:6px">Try a brand, model number or SKU, or browse a department.</span>' +
      (chips ? '<span class="khc-chips" style="justify-content:flex-start;margin-top:14px">' + chips + '</span>' : '') +
      (waHref ? '<a class="khc-btn" style="margin-top:14px" href="' + esc(waHref) + '" target="_blank" rel="noopener">Ask us on WhatsApp</a>' : '') + '</div>';
  }
  function renderSearch(q, list) {
    if (!list.length) { searchRes.innerHTML = emptyState(q); return; }
    var html = list.map(function (p) {
      var img = p.img ? (p.img.indexOf('width=') > -1 ? p.img : p.img + (p.img.indexOf('?') > -1 ? '&' : '?') + 'width=160') : '';
      return '<a class="khc-sr" href="' + esc(p.url) + '"><span class="khc-sr__img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="56" height="56">' : '') + '</span><span><span class="khc-sr__t">' + esc(shortTitle(p.title)) + '</span><span class="khc-sr__p">' + esc(money(p.price)) + '</span></span></a>';
    }).join('');
    html += '<a class="khc-sr khc-sr--all" href="/search?type=product&q=' + encodeURIComponent(q) + '">View all results</a>';
    searchRes.innerHTML = html;
  }
  function runSearch(q) {
    if (!searchRes) return;
    if (searchCtl && searchCtl.abort) searchCtl.abort();
    if (q.length < 2) { searchRes.innerHTML = ''; return; }
    searchCtl = window.AbortController ? new AbortController() : null;
    var opt = searchCtl ? { signal: searchCtl.signal } : {};
    var base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
    /* Primary: same ranking as the results page (search.suggest template). Fallback: native predictive endpoint. */
    fetch('/search?view=suggest&type=product&q=' + encodeURIComponent(q), opt)
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var arr = JSON.parse(t);
        return arr.map(function (p) { return { title: p.title, url: String(p.url).split('?')[0], price: p.price, img: p.image }; });
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') throw e;
        var url = base + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        return fetch(url, opt).then(function (r) { return r.json(); }).then(function (d) {
          var l = (((d || {}).resources || {}).results || {}).products || [];
          return l.map(function (p) { return { title: p.title, url: p.url, price: p.price, img: p.featured_image && p.featured_image.url }; });
        });
      })
      .then(function (list) { renderSearch(q, list); })
      .catch(function (e) { if (e && e.name === 'AbortError') return; searchRes.innerHTML = ''; });
  }
  function initSearch() {
    searchEl = $('[data-khc-search]');
    if (!searchEl || searchEl.getAttribute('data-ready')) return;
    searchEl.setAttribute('data-ready', '1');
    searchInput = $('input[name=q]', searchEl);
    searchRes = $('[data-khc-search-res]', searchEl);
    if (searchInput) {
      searchInput.addEventListener('input', function () {
        var q = searchInput.value.trim();
        clearTimeout(searchTimer);
        if (q === lastQ) return;
        lastQ = q;
        searchTimer = setTimeout(function () { runSearch(q); }, 200);
      });
    }
  }

  /* ---------- reveal on scroll ---------- */
  var io;
  function initReveal() {
    var els = $$('[data-khc-reveal]:not(.is-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    }
    els.forEach(function (e) {
      if (!e.style.getPropertyValue('--khc-d')) {
        var sibs = e.parentElement ? Array.prototype.filter.call(e.parentElement.children, function (c) { return c.hasAttribute('data-khc-reveal'); }) : [];
        var i = sibs.indexOf(e);
        if (i > 0) e.style.setProperty('--khc-d', Math.min(i, 6) * 0.06 + 's');
      }
      io.observe(e);
    });
  }

  /* ---------- hero video (only when a Shopify-hosted video is set) ---------- */
  function initVideo() {
    $$('video[data-khc-video]').forEach(function (v) {
      if (v.getAttribute('data-ready')) return;
      v.setAttribute('data-ready', '1');
      var saver = navigator.connection && navigator.connection.saveData;
      if (reduce || saver) { v.removeAttribute('autoplay'); v.pause(); return; }
      if (!('IntersectionObserver' in window)) { v.play().catch(function () {}); return; }
      new IntersectionObserver(function (en) {
        en.forEach(function (x) {
          if (x.isIntersecting) { if (v.preload === 'none') v.preload = 'auto'; v.play().catch(function () {}); } else { v.pause(); }
        });
      }, { threshold: 0.25 }).observe(v);
    });
  }

  /* ---------- product page: tab pills, read more, related products ---------- */
  function cents(v) { return money(parseFloat(v) / 100); }
  function imgUrl(u, w) {
    if (!u) return '';
    u = String(u);
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u.replace(/(\.[a-z]+)(\?|$)/i, '_' + w + 'x$1$2');
  }
  function initPdp() {
    var tabs = $('[data-khc-tabs]');
    if (tabs && !tabs.getAttribute('data-ready')) {
      tabs.setAttribute('data-ready', '1');
      var links = $$('[data-khc-tab]', tabs);
      var secs = links.map(function (a) { return document.getElementById(a.getAttribute('data-khc-tab')); });
      var upd = function () {
        var ft = $('.khc-footer');
        var nearFooter = ft ? ft.getBoundingClientRect().top < window.innerHeight - 60 : false;
        tabs.classList.toggle('is-on', window.scrollY > 160 && !nearFooter);
        var cur = links[0];
        secs.forEach(function (sc, i) { if (sc && sc.getBoundingClientRect().top < window.innerHeight * 0.5) cur = links[i]; });
        links.forEach(function (l) { l.classList.toggle('is-cur', l === cur); });
      };
      window.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    }
    $$('[data-khc-more]').forEach(function (b) {
      if (b.getAttribute('data-ready')) return;
      b.setAttribute('data-ready', '1');
      b.addEventListener('click', function () {
        var ed = b.closest('[data-khc-ed]');
        if (!ed) return;
        var open = ed.classList.toggle('is-open');
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
        b.textContent = open ? 'Show less' : 'Read full description';
      });
    });
    var rel = $('[data-khc-related]');
    if (rel && !rel.getAttribute('data-ready')) {
      rel.setAttribute('data-ready', '1');
      var id = rel.getAttribute('data-product-id');
      fetch('/recommendations/products.json?product_id=' + encodeURIComponent(id) + '&limit=4&intent=related')
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var list = (j.products || []).filter(function (p) { return p.available !== false; }).slice(0, 2);
          if (!list.length) return;
          var row = $('.khc-rel__row', rel);
          row.innerHTML = list.map(function (p) {
            return '<a class="khc-mini" href="' + esc(p.url) + '"><span class="khc-mini__i"><img src="' + esc(imgUrl(p.featured_image, 160)) + '" alt="" loading="lazy" width="52" height="52"></span>' +
              '<span><span class="khc-mini__t">' + esc(shortTitle(p.title)) + '</span><span class="khc-mini__p" style="display:block">' + esc(cents(p.price_min != null ? p.price_min : p.price)) + '</span></span>' +
              '<span class="khc-mini__go" aria-hidden="true">+</span></a>';
          }).join('');
          rel.hidden = false;
        })
        .catch(function () {});
    }
  }

  /* ---------- cart drawer: subtotal label, lock icon, related suggestion ---------- */
  var upTimer, upBusy = false;
  var LOCK = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17 9h-1V7a4 4 0 0 0-8 0v2H7a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2zm-7-2a2 2 0 1 1 4 0v2h-4V7z"/></svg>';
  function tidyPrices(root0) {
    /* the AED symbol now sits in its own <span> before the amount, so the leading "Dhs." text is gone;
       clean the remaining plain-text amount instead: drop a bare .00 and a redundant trailing currency code. */
    var w = document.createTreeWalker(root0, 4, null, false), n, list = [];
    while ((n = w.nextNode())) { if (/(\d)\.00(?!\d)|\bAED\b/.test(n.nodeValue)) list.push(n); }
    list.forEach(function (t) {
      var v = t.nodeValue.replace(/(\d)\.00(?!\d)/g, '$1').replace(/\s*\bAED\b/g, '');
      if (v !== t.nodeValue) t.nodeValue = v;
    });
  }
  function initUpsell() {
    var cd = $('cart-drawer');
    if (!cd) return;
    tidyPrices(cd);
    var tl = $('.totals__total', cd);
    if (tl && tl.textContent.trim() !== 'Subtotal') tl.textContent = 'Subtotal';
    var ck = $('.cart__checkout-button', cd);
    if (ck && !ck.querySelector('svg')) ck.insertAdjacentHTML('afterbegin', LOCK);
    var items = $('cart-drawer-items', cd);
    if (!items || items.classList.contains('is-empty') || $('.khc-upsell', cd) || upBusy) return;
    upBusy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) return null;
        var ids = cart.items.map(function (i) { return String(i.product_id); });
        return fetch('/recommendations/products.json?product_id=' + encodeURIComponent(ids[0]) + '&limit=6&intent=related')
          .then(function (r) { return r.json(); })
          .then(function (j) { return { list: (j.products || []).filter(function (p) { return p.available !== false && ids.indexOf(String(p.id)) < 0; }), ids: ids }; });
      })
      .then(function (res) {
        upBusy = false;
        if (!res || !res.list.length || $('.khc-upsell', cd)) return;
        var p = res.list[0];
        var single = p.variants && p.variants.length === 1 && p.variants[0].available;
        var box = document.createElement('div');
        box.className = 'khc-upsell';
        box.innerHTML = '<h3>You may also like</h3><div class="khc-up"><span class="khc-up__i"><img src="' + esc(imgUrl(p.featured_image, 160)) + '" alt="" loading="lazy" width="56" height="56"></span>' +
          '<div><div class="khc-up__t">' + esc(shortTitle(p.title)) + '</div><div class="khc-up__p">' + esc(cents(p.price_min != null ? p.price_min : p.price)) + '</div></div>' +
          (single ? '<button type="button" class="khc-up__btn" data-khc-up-add="' + p.variants[0].id + '">+ Add</button>' : '<a class="khc-up__btn" href="' + esc(p.url) + '">View</a>') + '</div>';
        var cur = $('cart-drawer-items', cd);
        if (cur && cur.parentNode) cur.parentNode.insertBefore(box, cur.nextSibling);
      })
      .catch(function () { upBusy = false; });
  }
  function addUpsell(btn) {
    var cart = $('cart-drawer');
    var fd = new FormData();
    fd.append('id', btn.getAttribute('data-khc-up-add'));
    fd.append('quantity', '1');
    var can = cart && typeof cart.getSectionsToRender === 'function' && typeof cart.renderContents === 'function';
    if (can) { fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; })); fd.append('sections_url', window.location.pathname); }
    btn.disabled = true;
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) { btn.disabled = false; return; }
        if (can) cart.renderContents(state); else window.location = (window.routes && window.routes.cart_url) || '/cart';
      })
      .catch(function () { btn.disabled = false; });
  }
  function watchCart() {
    var cd = $('cart-drawer');
    if (!cd || cd.getAttribute('data-khc-watch') || !window.MutationObserver) return;
    cd.setAttribute('data-khc-watch', '1');
    new MutationObserver(function () { clearTimeout(upTimer); upTimer = setTimeout(initUpsell, 60); }).observe(cd, { childList: true, subtree: true });
    initUpsell();
  }

  /* ---------- global events ---------- */
  document.addEventListener('click', function (e) {
    var nx = e.target.closest('[data-khc-next]'), pv = e.target.closest('[data-khc-prev]');
    if (nx || pv) {
      var w = (nx || pv).closest('[data-khc-scroller]');
      var s = w && $('.khc-scroller', w);
      if (s) s.scrollBy({ left: (nx ? 1 : -1) * s.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
      return;
    }
    var ua = e.target.closest('[data-khc-up-add]');
    if (ua) { e.preventDefault(); addUpsell(ua); return; }
    if (e.target.closest('[data-khc-search-open]')) { e.preventDefault(); closeMega(); openSearch(); return; }
    if (e.target.closest('[data-khc-search-close]')) { closeSearch(); return; }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeSearch(); closeMega();
      var m = hdr && $('.khc-mobile.is-open', hdr);
      if (m) { m.classList.remove('is-open'); var b = $('[data-khc-burger]', hdr); if (b) b.setAttribute('aria-expanded', 'false'); if (scrim) scrim.classList.remove('is-on'); }
    }
    if ((e.key === '/' || (e.key === 'k' && (e.metaKey || e.ctrlKey))) && !/input|textarea|select/i.test((e.target.tagName || '')) && searchEl) {
      e.preventDefault(); openSearch();
    }
  });
  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('khc-scroller')) syncScroller(e.target);
  }, true);

  function init() {
    $$('.khc-scroller').forEach(syncScroller);
    initHeader(); initSearch(); initReveal(); initVideo(); initPdp(); watchCart();
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', function () { $$('.khc-scroller').forEach(syncScroller); });
  document.addEventListener('shopify:section:load', function () { hdr = null; init(); });
})();
